import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class BlockMessageThreadUserArgs {
  @Field(t => Int)
  userId!: number

  @Field()
  reportUser!: boolean
}

@ArgsType()
export class UnblockMessageThreadUserArgs {
  @Field(t => Int)
  userId!: number
}
